import { connect } from 'react-redux';
import Adjustment from './adjustment';

export default connect()(Adjustment);
